export default __webpack_public_path__ + "static/media/user-face.29279b7c.png";